<ng-container *transloco="let t">
  <app-admin-modal-layout
    [title]="title ?? ''"
    (onSave)="onSaveButtonClick()"
    (onClose)="onClose()">

    <div class="pb-4">
      <form [formGroup]="inputForm">
        <app-language-input [inputForm]="inputForm"
                            [defaultLanguage]="event?.defaultLanguage"
                            [extraLanguages]="event?.extraLanguages"
                            [hrKey]="'hr'"
                            [enKey]="'en'"
                            [srKey]="'sr'"
                            [bsKey]="'bs'"
                            [itKey]="'it'"
                            [siKey]="'sl'"
                            [hrLabel]="'event.item.nameCro.short'"
                            [enLabel]="'event.item.nameEn.short'"
                            [bsLabel]="'event.item.nameBs.short'"
                            [srLabel]="'event.item.nameSr.short'"
                            [itLabel]="'event.item.nameIt.short'"
                            [siLabel]="'event.item.nameSlo.short'"
                            [required]="false"/>
      </form>
    </div>

  </app-admin-modal-layout>
</ng-container>
